import React, { useMemo, useState } from 'react';

import Modal from 'components/shared/Modal';
import Button from 'components/shared/Button';

import type { PhotoUpload, NamedCollection } from 'domains/photos';

type MovePhotoModalProps = {
  photo: PhotoUpload;
  collections: NamedCollection[];
  onCancel: () => void;
  onConfirm: (id: number, collection: string) => void;
};

function MovePhotoModal({ photo, collections, onCancel, onConfirm }: MovePhotoModalProps) {
  const availableCollections = useMemo(
    () => collections.filter((c) => c.name !== photo.collection),
    [photo, collections]
  );

  const [selected, setSelected] = useState(() => availableCollections[0].name);

  const buttons = (
    <React.Fragment>
      <Button type="confirm" onClick={() => onConfirm(photo.id, selected)}>
        Confirm
      </Button>
      <Button type="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </React.Fragment>
  );

  return (
    <Modal
      modalClass={['move-photo-modal']}
      labelledBy="move-photo-modal"
      title="Change Photo Collection"
      lastFocusedElementId={`${photo.original_filename}-${photo.id}-navigation-tile`}
      onClose={onCancel}
      primaryFooterGroup={buttons}
    >
      <div>
        <img src={photo.file_path_thumb} />
      </div>
      <p>
        Move <span>{photo.original_filename}</span> from <span>{photo.collection}</span>
      </p>

      <label htmlFor="select-collection">to</label>
      <select
        id="select-collection"
        onChange={(e) => setSelected(e.target.value)}
        value={selected}
        onClick={(e) => e.stopPropagation()}
      >
        <option value={undefined}>Select new collection</option>
        {availableCollections.map((collection) => (
          <option
            key={`${collection.name}`}
            value={collection.name}
            onClick={(e) => {
              e.nativeEvent.stopImmediatePropagation();
            }}
          >
            {collection.name} ({collection.count} images)
          </option>
        ))}
      </select>
    </Modal>
  );
}

export default MovePhotoModal;
